import api from "./Axios";

const ContactInfo = {
    contact_phone: "+966562805932",
    contact_phone2: "+923461191138",
    contact_email: "umargul692002@gmail.com",
    contact_email2: "z9677678.1@gmail.com",
    address: "Al Malaz, Riyadh, Saudi Arabia",
    facebook: "https://facebook.com",
    twitter: "https://facebook.com",
    linkedin: "https://facebook.com",
    instagram: "https://facebook.com",
    youtube: "https://facebook.com",
}


const teamMembers = [
    {id: 1, name: "Alice Smith", title: "Project Manager"},
    {id: 2, name: "Bob Johnson", title: "Software Engineer"},
    {id: 3, name: "Catherine Lee", title: "UX Designer"},
    {id: 4, name: "David Brown", title: "Data Analyst"},
    {id: 5, name: "Emily Davis", title: "Marketing Specialist"},
    {id: 6, name: "Frank Wilson", title: "Quality Assurance"},
    {id: 7, name: "Grace Taylor", title: "Content Strategist"},
    {id: 8, name: "Henry Moore", title: "DevOps Engineer"},

];

const get_services = async () => {
    try {
        const result = await api.get("services/");
        return result.data
    } catch (error) {
        console.log(error.message);
    }
};

const get_projects = async () => {
    try {
        const result = await api.get("project/");
        return result.data
    } catch (error) {
        console.log(error.message);
    }
};

const get_team_members = async () => {
    try {
        const result = await api.get("team-members/");
        return result.data
    } catch (error) {
        console.log(error.message);
    }
};


const get_ai_models = async () => {
    try {
        const result = await api.get("ai_models/");
        return result.data
    } catch (error) {
        console.log(error.message);
    }
};

const server_ip = 'https://company-profile-eosin-three.vercel.app'

export {ContactInfo, teamMembers, server_ip, get_services, get_projects, get_team_members, get_ai_models}
